
import React, { Component } from 'react'
import { connect } from 'react-redux'

import {List, ListItem} from 'material-ui/List'

import PropertyForm from './propertyForm'
import Communication from 'components/Communication'
import PerfomanceSection from './PerfomanceSection'

import { currentUser } from 'selectors/common'

let select = (state, props) => ({
	currentUser: currentUser(state)
  , selectedProperty: state.selectedProperty
})


export class Details extends Component {
	render() {
		let { props } = this
		return (
			<div style={{backgroundColor: "rgb(237, 237, 237)"}}>
				{(props.selectedProperty || props.oneProperty) && <PropertyForm id={props.oneProperty ? props.detailID : props.selectedProperty} oneProperty={props.oneProperty}/>}
				{!(props.selectedProperty || props.oneProperty) && <div style={{width:"100%", height:"calc(100vh - 60px)", overflowX: "hidden"}}>
					<div style={{width:"100%", display:"flex", minHeight:"calc(100vh - 60px)", overflowX: "hidden", overflowY: "hidden"}}>
						<div
							className="left-side"
							style={{
								 width: "50%"
								   , overflowY: "auto"
							   , overflowX: "hidden"
								   , minHeight: "calc(100vh - 60px)"
							   , padding: "6px"
							}}
						>
							<List
								className="dashboard-left"
								style={{
									width: "98%"
								  , float: "left"
								  , margin: "4px"
								}}
							>
										<div style={{
											width: "100%"
											, float: "left"
										}}>
											<List
												className="dashboard-Finance"
												style={{
													width: "100%"
													, float: "left"
													, marginTop: "-7px"
									                , padding: "0"
									                , boxShadow: "rgba(0, 0, 0, 0.12) 0px 1px 6px, rgba(0, 0, 0, 0.12) 0px 1px 4px"
													, backgroundColor: "#FFF"
												}}
											>
												<PerfomanceSection selectedProperty={props.selectedProperty}/>
											</List>
										</div>
							</List>
						</div>
						<div className="rightSide"
							style={{
								width: "50%"
							  , position: "relative"
							  , display: "block"
							  , paddingTop: "7px"
							}}
						>
							<List
								className="dashboard-inbox"
								style={{
									width: "98%"
								  , float: "left"
								  , margin: "4px"
								  , padding: "0"
								}}
							>
								<Communication objectID={"all"} path={this.props.path}  />
							</List>
						</div>
					</div>
				</div>}
			</div>
		)
	}
}

export default connect(select)(Details)



// WEBPACK FOOTER //
// ./src/routes/landlord/dashboard/Details.js